import React, {useEffect, useState} from 'react';
import {Form, Formik} from 'formik';
import {
    Autocomplete,
    Button,
    Grid,
    InputLabel,
    ListItemText,
    MenuItem,
    Select,
    SelectChangeEvent,
    TextField
} from '@mui/material';
import DataField from '../../atoms/dataField';
import Picker from '../../atoms/picker';
import TriggerRow from '../../molecules/triggerRow';
import Box from '@mui/material/Box';
import {IFormDropDown, IFormField} from '../../shared/globalTypes';
import SaveIcon from '@mui/icons-material/Save';
import DeleteSharpIcon from '@mui/icons-material/DeleteSharp'
import IconButton from '@mui/material/IconButton';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import InfoIcon from '@mui/icons-material/Info';
import FormControl from '@mui/material/FormControl';
import ActionRow from "../../molecules/actionRow";
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import cronstrue from 'cronstrue';
import Skeleton from '@mui/material/Skeleton';
import LoadingButton from '@mui/lab/LoadingButton';
import {DataGrid, GridCellEditCommitParams, useGridApiContext} from '@mui/x-data-grid';
import {IDataSourceFields} from '../dataSourceForm/index'
import {useDispatch, useSelector} from "react-redux";
import * as user from "../../../store/dataSource/selectors";
import {
    getAccessControlPendingSelector,
    getAccessControlSelector,
    getSourceSelector,
    getStewardSelector
} from "../../../store/dataSource/selectors";
import * as extractorDBData from "../../../store/extractor/selectors";
import {
    getExtractorStatusSelector,
    getPatternsSelector,
    postcustExtErrorSelector,
    postCustExtSelector,
    postDBExtSelector
} from "../../../store/extractor/selectors";
import {
    getExtTableMetaDataSelector,
    getFoundryMetaDataSelector,
    postDataErrorSelector
} from "../../../store/extractor/metaData/selectors";
import * as constants from '../../../constants/_pickerValues';
import * as accessControlDispatch from '../../../store/dataSource/actions';
import {fetchSourceDetailsReq} from '../../../store/dataSource/actions';
import { IAccessControl, ISearchParam } from '../../../store/dataSource/types';
import { IDeleteParams, IExtractorListParams, IExtractorPatterns, LayerType } from '../../../store/extractor/types';
import {IUser} from '../../../store/groups/types';
import {fetchExtTableMetaDataReq, fetchFoundryTableMetaDataReq} from "../../../store/extractor/metaData/action";
import * as dbExtractor from '../../../store/extractor/actions';
import * as statusDispatch from '../../../store/extractor/actions';
import { deleteExtractorReq, fetchExtractorDetailReq, fetchPatternsReq } from '../../../store/extractor/actions';
import {useParams} from 'react-router';
import * as functions from '../../shared/functions';
import {
    convertUTCDateToLocalDate,
    getPrivacyClassificationText,
    getPrivacyPayloadText,
    getSecurityClassificationText,
    getSecurityPayloadText
} from '../../shared/functions';
import ExtractorStatus from '../../molecules/extractorStatus/ExtractorStatus'
import ProgressPopup from '../../molecules/progressPopup/ProgressPopup'
import AvroGenerator from '../../molecules/avroGenerator/AvroGenerator';
import SqlGenerator from '../../molecules/sqlGenerator/SqlGenerator';
import {getJobListSelector} from '../../../store/timeBasedTrigger/selectors'
import * as jobDispatch from '../../../store/timeBasedTrigger/actions';
import {IJobListParams} from '../../../store/timeBasedTrigger/types';
import * as taskDispatch from '../../../store/eventBasedTrigger/actions';
import {ITaskListParams} from '../../../store/eventBasedTrigger/types';
import {
    getEventListPendingSelector,
    getEventListSelector,
    getInboundListPendingSelector,
    getInboundListSelector,
    getOutboundListPendingSelector,
    getOutboundListSelector,
    getTaskListSelector
} from '../../../store/eventBasedTrigger/selectors';
import {getOutboundWebhookListSelector} from '../../../store/webhooks/selectors';
import {useLocation, useNavigate} from "react-router-dom";
import {getProfileDataSelector, getRoleClaimsSelector} from '../../../store/auth/selectors';
import {getProfileSelector} from '../../../store/userProfile/selectors';
import {IProfile} from "../../../store/userProfile/types";
import * as getProfile from "../../../store/userProfile/actions";
import {IDP_USERS_PRODUCTION} from "../../../constants/common";
import {
    deleteSubscriptionSelector,
    fetchSubscriptionPendingSelector,
    fetchSubscriptionSelector,
    postExtractorSubscriptionSelector
} from '../../../store/subscriptions/selectors';
import NotificationsIcon from '@mui/icons-material/Notifications';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import {
    deleteSubscriptionReq,
    fetchSubscriptionRequest,
    fetchSubscriptionReset,
    postExtractorSubscriptionRequest,
    postExtractorSubscriptionReset
} from '../../../store/subscriptions/actions';
import {ISubscriptionSearchParams} from '../../../store/subscriptions/types';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import AppConfig from "../../../config/AppConfig";
import { CustomizedDialogs } from '../../atoms';
import { fetchLoadersReq } from '../../../store/dataLoader/actions';

export interface TableProps {
    tableName?: string
    submitTablesData?: any
    dataSourceData?: IDataSourceFields
    accessControlGroup?: string[]
    dataStewardGroup?: string,
    dataStewardIDs?: IUser[],
    selectedSchemas?: [],
    tableIndex?: number,
    sourceID?: number,
    extractorTableData?: any,
    setErrorList?: any,
    mode?: string;
    connection?: string,
    dataSourceName?: string,
    customSQL?: boolean,
    spokeName?: string,
    endpoint?: string
};

export interface IConfigureTableFields {
    name: IFormField;
    description: IFormField;
    schemaName: IFormField;
    dataSetName: IFormField;
    customsql: IFormField;
    path: IFormField;
    regex: IFormField;
    headerRows: IFormField;
    securityClassification: IFormDropDown;
    privacyClassification: IFormDropDown;
    fileType: IFormDropDown;
    dataStewards: IFormDropDown;
    blobContainer: IFormField;
    fieldDelimeter: IFormField;
    manifestFileFlag: IFormField;
    escapeChar: IFormField;
    textDelimiter: IFormField;
    deleteFiles: IFormField;
}

// Trigger Types
export type triggerTypeList = {
    key: number,
    repeat?: string,
    timezone?: string,
    webhook?: string,
};

// Action Types
export type actionTypeList = {
    key: number,
    outboundWebhook?: string,
    headers?: string,

};


// Triggers Initial State
export const triggerListInitialState = [
    {
        key: 0
    }
]

// Actions Initial State
export const actionListInitialState = [
    {
        key: Date.now()
    }
]

let cellEnablePrivacy = false;

export const ConfigureTablesForm = (props: TableProps) => {
    // prompt to prevent user from leaving form
    const [changes, setChanges] = useState(false)

    const { mode, connection } = props
    let AccessControlsInitial: string[] = props.accessControlGroup ? props.accessControlGroup : [constants.IDP_PROD_USERS];
    let DataStewardIDsInitial: IUser[] = props.dataStewardIDs ? props.dataStewardIDs : []

    const { tableName, submitTablesData, dataSourceData, selectedSchemas, tableIndex, spokeName } = props;


    // getting selected schema
    const filteredSchemaNames = selectedSchemas?.map((item: any) => {
        const b = item.tableInfo?.filter((itm: any) => itm.name === tableName);
        return b.length > 0 ? item.name : null
    })
    const singleSchema = filteredSchemaNames?.filter((ite: any) => { return ite !== null });
    const schName: string = singleSchema ? singleSchema[0] : ""; //  Note to Liz - change when API fixed

    // setting the initial state
    let ConfigureTablesInitialState: IConfigureTableFields = {
        name:
            { fieldValue: "", isError: false, errorMsg: "", isNumber: false, },
        description:
            { fieldValue: "", isError: false, errorMsg: "", isNumber: false, },
        schemaName:
            { fieldValue: connection === constants.CONNECTION_TYPES.foundry ? "master" : schName, isError: false, errorMsg: "", isNumber: false, },
        dataSetName:
            { fieldValue: connection === "S3 Buckets" || connection === "Windows Fileshare" || props.customSQL || connection === constants.CONNECTION_TYPES.azure ? '' : tableName ? tableName : '', isError: false, errorMsg: "", isNumber: false, },
        path:
            { fieldValue: "", isError: false, errorMsg: "", isNumber: false, },
        regex:
            { fieldValue: "", isError: false, errorMsg: "", isNumber: false, },
        blobContainer:
            { fieldValue: "", isError: false, errorMsg: "", isNumber: false, },
        customsql:
            { fieldValue: "", isError: false, errorMsg: "", isNumber: false, },
        fieldDelimeter:
            { fieldValue: "", isError: false, errorMsg: "", isNumber: false, },
        manifestFileFlag:
            { fieldValue: "FALSE", isError: false, errorMsg: "", isNumber: false, },
        headerRows:
            { fieldValue: "", isError: false, errorMsg: "", isNumber: false, },
        privacyClassification:
            { fieldValue: dataSourceData?.privacyClassification.fieldValue ? dataSourceData?.privacyClassification.fieldValue === " " ? "" : dataSourceData?.privacyClassification.fieldValue : "", isError: false, errorMsg: "" },
        securityClassification:
            { fieldValue: dataSourceData?.securityClassification.fieldValue ? dataSourceData?.securityClassification.fieldValue === " " ? "" : dataSourceData?.securityClassification.fieldValue : "", isError: false, errorMsg: "" },
        dataStewards:
            { fieldValue: "", isError: false, errorMsg: "", },
        fileType:
            { fieldValue: "", isError: false, errorMsg: "", },
        escapeChar:
            { fieldValue: "", isError: false, errorMsg: "", isNumber: false, },
        textDelimiter:
            { fieldValue: "", isError: false, errorMsg: "", isNumber: false, },
        deleteFiles:
            { fieldValue: "", isError: false, errorMsg: "", isNumber: false, },
    }


    const dispatch = useDispatch();

    // get extractor details
    const extractorDetail = useSelector(extractorDBData.getExtractorDetailSelector);
    const loadingExtractorDetail = useSelector(extractorDBData.getExtractorDetailPendingSelector);
    const foundryMetaData = useSelector(getFoundryMetaDataSelector);

    const extractorListParams: IExtractorListParams = {
        skip: 0,
        top: 1,
        count: true,
        orderby: `description asc`,
        search: tableName !== undefined ? tableName : ""
    };

    //Get extractor List
    const extractorList = useSelector(extractorDBData.getExtractorListSelector);

    const { batchCode } = useParams();
    useEffect(() => {

        // When batchcode is available, when it is either VIEW or EDIT

        if (props.mode !== constants.MODE.add && batchCode) {
            extractorListParams.search = batchCode
            dispatch(fetchExtractorDetailReq(batchCode));
            dispatch(dbExtractor.fetchExtractorListReq(extractorListParams));
        }

    }, [batchCode]);

    // loads page from top
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    // selectors
    const stewardData = useSelector(getStewardSelector).sort((a, b) => a.userName.toLowerCase().localeCompare(b.userName.toLowerCase()));
    const accessControls = useSelector(getAccessControlSelector);
    const accessControlsPending = useSelector(getAccessControlPendingSelector);
    const patterns = useSelector(getPatternsSelector);
    const authProfile = useSelector(getProfileDataSelector);
    const postExtractorSubscriptionSuccess = useSelector(postExtractorSubscriptionSelector)
    const deleteSubscriptionSuccess = useSelector(deleteSubscriptionSelector);
    const subscriptionList = useSelector(fetchSubscriptionSelector);
    const subscriptionPendingList = useSelector(fetchSubscriptionPendingSelector);
    // get Custom Extractor batchCode
    const custExtbatchCode = useSelector(postCustExtSelector)
    // for Custom Extractor & DBExtractor error handling
    const custExtError = useSelector(postcustExtErrorSelector)
    const dbExtError = useSelector(postDataErrorSelector)

    const dataStewardGroupValue = props.dataStewardGroup ? props.dataStewardGroup : '';
    // state values
    const [displayTriggers, setDisplayTriggers] = useState(false);
    const [displayActions, setDisplayActions] = useState(false);
    const [displayEditBtn, setDisplayEditBtn] = useState(false);
    const [configureTablesData, setConfigureTablesData] = useState(ConfigureTablesInitialState);
    const [triggers, setTriggers] = useState(triggerListInitialState)
    const [actions, setActions] = useState(actionListInitialState)
    const [accessControlGroup, setAccessControlGroup] = useState<Array<string>>(AccessControlsInitial);
    const [dataStewardGroup, setDataStewardGroup] = useState(dataStewardGroupValue);
    const [comparisonKey, setComparisonKey] = useState<Array<string>>([]);
    const [subscriptionPending, setSubscriptionPending] = useState(false);
    const [subscribed, setSubscribed] = useState(false);
    const [subscriptionId, setSubscriptionId] = useState("");
    const [dataStewardIDs, setDataStewardIDs] = useState(DataStewardIDsInitial);
    const [extract, setExtract] = useState<string>('');
    const [staging, setStaging] = useState<string>('');
    const [history, setHistory] = useState<string>('');
    const [landing, setLanding] = useState<string>('');
    const [columnGovernance, setColumnGovernance] = useState<any>();
    const [disablePrivacy, setDisablePrivacy] = useState(false);
    const [createdBy, setCreatedBy] = useState('');
    const [createdOn, setCreatedOn] = useState('');
    const [lastModified, setLastModified] = useState('');
    const [lastRefreshed, setLastRefreshed] = useState('');
    const [lastUpdated, setLastUpdated] = useState('');
    const [avroCode, setAvroCode] = useState('')
    const [sqlCode, setSqlCode] = useState('');
    //create extractor processing
    const [processingExtractor, setProcessingExtractor] = useState(false)
    const userData = useSelector(user.postDataSelector)
    const sourceID = userData?.sourceId ? userData?.sourceId : Number(props.dataSourceData?.sourceID.fieldValue)
    const [sourceId, setSourceId] = useState<any>();
    const [eventList, setEventList] = useState<any>();
    const [outbound, setOutbound] = useState<any>();
    const [stewards, setStewards] = useState<any>();
    const [layerType, setLayerType] = useState("")
    const [mail, setMail] = useState("")
    const navigate = useNavigate();
    const getDataSource = useSelector(getSourceSelector);
    const [profile, setProfile] = useState<IProfile[]>([])
    const [isAdmin, setIsAdmin] = useState(false);
    const [taskDisabled, setTaskDisabled] = useState(false);
    const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);

    // get DBExtractor batchCode
    const dbBatchCode = useSelector(postDBExtSelector)

    const statusList = useSelector(getExtractorStatusSelector);
    // current user
    const userProfile = useSelector(getProfileSelector);
    // roles  - IDP.Admin or IDP.User
    const roles: string[] = useSelector(getRoleClaimsSelector);

    useEffect(() => {
        if (!changes) return;
        const handleBeforeUnload = (e: BeforeUnloadEvent) => {
            if (mode !== constants.MODE.view && changes) {
                e.preventDefault();
            }
            else {
                window.onbeforeunload = null;
            }
        };

        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [changes, mode]);

    useEffect(() => {
        if (roles && roles.length > 0) {
            setIsAdmin(roles.includes("IDP.Admin") ? true : false);
        }
    }, [roles])

    useEffect(() => {
        if (userProfile) {
            // get individual profile
            setProfile(userProfile)
        }
    }, [userProfile]);

    useEffect(() => {
        if (mail) {
            dispatch(getProfile.fetchProfileRequest({ userName: mail }));
        }
    }, [mail]);

    const goBack = () => {
        dispatch(dbExtractor.postDBExtReset());
        dispatch(dbExtractor.postCustomExtReset());
        dispatch(statusDispatch.fetchExtractorStatusReset());
        dispatch(postExtractorSubscriptionReset());
        dispatch(fetchSubscriptionReset())
        window.history.back();
        setChanges(false)
    };
    useEffect(() => {
        if (props.mode !== constants.MODE.add && batchCode) {
            dispatch(statusDispatch.fetchExtractorStatusReq(batchCode));
        }

    }, [batchCode]);

    // Update extractor details if it's view mode
    useEffect(() => {
        if (mode === constants.MODE.view && extractorDetail) {
            configureTablesData.name.fieldValue = extractorDetail?.businessMetadata?.name;
            configureTablesData.description.fieldValue = extractorDetail?.businessMetadata?.description;
            configureTablesData.schemaName.fieldValue = extractorDetail?.businessMetadata?.schema;
            configureTablesData.dataSetName.fieldValue = extractorDetail?.businessMetadata?.tableName === null ? 'Not Available' : extractorDetail?.businessMetadata?.tableName;
            configureTablesData.securityClassification.fieldValue = getSecurityClassificationText(extractorDetail?.businessMetadata?.securityClassification)!;
            configureTablesData.privacyClassification.fieldValue = getPrivacyClassificationText(extractorDetail?.businessMetadata?.privacyClassification)!;
            setComparisonKey([extractorDetail?.mappingAttributes]);
            setDisablePrivacy(true)
            setDataStewardGroup(extractorDetail?.businessMetadata?.dataStewards === null ? 'Not Available' : extractorDetail?.businessMetadata?.dataStewards)
            var array = extractorDetail?.businessMetadata?.dataStewards === null ? ['Not Available'] : extractorDetail?.businessMetadata?.dataStewards.split(',');
            setStewards(array)
            configureTablesData.blobContainer.fieldValue = extractorDetail?.fileRegistration?.blobContainer!;
            configureTablesData.fileType.fieldValue = extractorDetail?.fileRegistration?.extension ? extractorDetail?.fileRegistration?.extension.toUpperCase() : '';
            configureTablesData.fieldDelimeter.fieldValue = extractorDetail?.fileRegistration?.fieldDelimeter!;
            configureTablesData.headerRows.fieldValue = extractorDetail?.fileRegistration?.isHeader ? extractorDetail?.fileRegistration?.isHeader.toString().toUpperCase() : 'FALSE';
            configureTablesData.manifestFileFlag.fieldValue = extractorDetail?.fileRegistration?.manifestFileFlag ?? "FALSE";
            configureTablesData.regex.fieldValue = extractorDetail?.fileRegistration?.wildcardExpression!;
            configureTablesData.textDelimiter.fieldValue = extractorDetail?.fileRegistration?.textDelimiter!;
            configureTablesData.escapeChar.fieldValue = extractorDetail?.fileRegistration?.escapeChar!;
            configureTablesData.deleteFiles.fieldValue = extractorDetail?.fileRegistration?.deleteFlag!;
            setAccessControlGroup(extractorDetail?.businessMetadata?.accessControls)
            setExtract(extractorDetail?.extPattern === null ? '-1' : extractorDetail?.extPattern?.selectedPatternId)
            setStaging(extractorDetail?.stgPattern === null ? '-1' : extractorDetail?.stgPattern?.selectedPatternId)
            setHistory(extractorDetail?.hstgPattern === null ? '-1' : extractorDetail?.hstgPattern?.selectedPatternId)
            setLanding(extractorDetail?.lndPattern === null ? '-1' : extractorDetail?.lndPattern?.selectedPatternId)

            setCreatedBy(extractorDetail?.createdBy)
            setSourceId(extractorDetail?.sourceLayer?.id)
            setLastUpdated(extractorDetail?.lastUpdatedBy)
            setLastModified(convertUTCDateToLocalDate(extractorDetail?.lastModifiedOn).toString())
            setCreatedOn(convertUTCDateToLocalDate(extractorDetail?.createdOn).toString())
            setLastRefreshed(convertUTCDateToLocalDate(extractorDetail?.lastRefreshDate).toString())
            configureTablesData.customsql.fieldValue = extractorDetail?.customSql;
            const newRows = extractorDetail?.columnGovernanceMetadata.sort((a, b) => (a.ordinal > b.ordinal) ? 1 : -1).map((item: any, index: number) => {
                return {
                    srcColumnName: item.columnId, treatmentLevel: functions.capitalizeFirstLetter(item.treatmentLevel), securityClassification: getSecurityClassificationText(item.securityClassification),
                    privacyClassification: getPrivacyClassificationText(item.privacyClassification), id: index
                };
            });

            if (extractorDetail.sourceLayer?.layerType !== constants.EXTRACT_TYPES.adls) {
                dispatch(fetchPatternsReq({ layerType: LayerType.EXT, sourceId: Number(extractorDetail?.sourceLayer?.id) }));
            }
            dispatch(fetchPatternsReq({ layerType: LayerType.LND, sourceId: Number(extractorDetail?.sourceLayer?.id) }));
            dispatch(fetchPatternsReq({ layerType: LayerType.HSTG, sourceId: Number(extractorDetail?.sourceLayer?.id) }));
            setColumnGovernance(newRows)
            setChanges(true)
            if (extractorDetail.createdBy + ("@riotinto.com") === authProfile.mail) { setDisplayEditBtn(true) }
            else { setDisplayEditBtn(false) }
        } else {


        }

    }, [extractorDetail, mode]);
    // getting triggers (job list) in view extractor mode

    // getting layer type
    useEffect(() => {
        if (getDataSource) {
            setLayerType(getDataSource["layerType"]);
        }
    }, [getDataSource, mode]);

    // set user mail
    useEffect(() => {
        if (mode === constants.MODE.view && authProfile) {
            setMail(authProfile.userPrincipalName)
        }
    }, [authProfile]);

    useEffect(() => {
        if (mode === constants.MODE.view && sourceId) {
            dispatch(fetchSourceDetailsReq(Number(sourceId)));
        }
    }, [sourceId, mode]);

    useEffect(() => {
        dispatch(accessControlDispatch.fetchStewardRequest(IDP_USERS_PRODUCTION));
        if (!accessControlsPending && accessControls.length <= 0) {
            dispatch(accessControlDispatch.fetchAccessControlRequest());
        }
        if (dataStewardGroup) {
            dispatch(accessControlDispatch.fetchStewardRequest(dataStewardGroup));
        }
        if (sourceID !== undefined && mode !== constants.MODE.view) {
            if (connection !== constants.CONNECTION_TYPES.azure) {
                dispatch(fetchPatternsReq({ layerType: LayerType.EXT, sourceId: sourceID }));
            }
            dispatch(fetchPatternsReq({ layerType: LayerType.LND, sourceId: sourceID }));
            dispatch(fetchPatternsReq({ layerType: LayerType.HSTG, sourceId: sourceID }));
            dispatch(fetchSourceDetailsReq(sourceID));
        }

        // resetting triggers and actions and batchcode on page load to remove old data
        dispatch(dbExtractor.postDBExtReset());
        dispatch(dbExtractor.postCustomExtReset());

        //Subscriptions
        dispatch(postExtractorSubscriptionReset());
        dispatch(fetchSubscriptionReset())
        //dispatch(deleteSubscriptionReset())

        if (connection === constants.CONNECTION_TYPES.azure) {
            setExtract('-1');
        }
    }, []);

    // Populate names for stewards based on selected data steward AD group

    useEffect(() => {
        if (dataStewardGroup) {
            dispatch(accessControlDispatch.fetchStewardRequest(dataStewardGroup));
        }
    }, [dataStewardGroup]);


    const params: IJobListParams = {
        taskCode: batchCode ? batchCode : ''
    };

    const extractorParams: ITaskListParams = {
        taskType: 'Extract_Task',
        taskCode: batchCode ? batchCode : ''
    };

    useEffect(() => {
        if (mode === constants.MODE.view) {

            dispatch(jobDispatch.fetchJobListReq(params));
            dispatch(taskDispatch.fetchTaskListReq(extractorParams));
        }
    }, []);

    const jobs = useSelector(getJobListSelector);
    const taskList = useSelector(getTaskListSelector);
    const acList = useSelector(getOutboundWebhookListSelector);


    useEffect(() => {
        setJobList(jobs);
    }, [jobs]);

    useEffect(() => {
        setTasks(taskList);
    }, [taskList]);

    useEffect(() => {
        setActionList(acList);
    }, [acList]);



    const [jobList, setJobList] = useState<any>();
    const [tasks, setTasks] = useState<any>();
    const [actionList, setActionList] = useState<any>();

    // fetching events, inbound and outbound webhook

    useEffect(() => {
        if (mode === constants.MODE.view) {
            if (tasks && tasks.length > 0) {
                if (tasks[0].enabled === null && tasks[0].taskId === null) {
                    setTaskDisabled(true);
                } else {
                    setTaskDisabled(tasks[0].enabled);
                }
                const inboundWebhookParams = {
                    eventType: 'WEB_HOOK.INBOUND',
                    eventActionValue: tasks && tasks.length > 0 && tasks[0].id
                };

                const outboundWebhookParams = {
                    eventAction: 'CALL_WEB_HOOK',
                    eventQualifier: tasks && tasks.length > 0 && tasks[0].id

                };
                const eventListParams = {
                    eventActionValue: tasks[0].id
                };
                dispatch(taskDispatch.fetchInboundListReq(inboundWebhookParams));
                dispatch(taskDispatch.fetchOutboundListReq(outboundWebhookParams));
                dispatch(taskDispatch.fetchEventListReq(eventListParams))
            }


        }
    }, [tasks]);


    // returns all events (includes inbound and extractor based triggers)
    const getEvents = useSelector(getEventListSelector)
    const inboundList = useSelector(getInboundListSelector);
    const outboundList = useSelector(getOutboundListSelector);
    const eventsPending = useSelector(getEventListPendingSelector)
    const outboundPendingList = useSelector(getOutboundListPendingSelector);
    const inboundPendingList = useSelector(getInboundListPendingSelector);


    useEffect(() => {
        setOutbound(outboundList);
    }, [outboundList]);

    useEffect(() => {
        setEventList(getEvents);
    }, [getEvents]);

    useEffect(() => {
        if (mode === "Add" && sourceID !== undefined && props.connection !== "S3 Buckets" && props.connection !== "Windows Fileshare" && props.connection !== "Foundry" && props.connection !== constants.CONNECTION_TYPES.azure && !props.customSQL) {
            // adding treatment, security classification, privacy classification fields to column governance data
            const tableInfo = {
                layer_id: sourceID,
                schema: schName,
                table_name: tableName ? tableName : ''
            }
            dispatch(fetchExtTableMetaDataReq(tableInfo));
        }
        if (mode === "Add" && props.connection === constants.CONNECTION_TYPES.foundry) {
            const foundryData = {
                src_id: sourceID,
                dataset_rid: configureTablesData.dataSetName.fieldValue
            }
            dispatch(fetchFoundryTableMetaDataReq(foundryData))
        }
    }, []);

    const extractorTableData = useSelector(getExtTableMetaDataSelector);
    const table_name = tableName ? tableName : ''

    // generate avro fields if amazon s3 bucket or windows fileshare
    const getAvroCode = (code: string) => {
        try {
            const getAvroValue = JSON.parse(code)
            const newRows = getAvroValue.fields?.map((item: any, index: number) => {
                let precision = 0
                let scale = 0
                if (item.unmodified_size && item.unmodified_size.includes(',')) {
                    precision = item.unmodified_size.split(',')[0]
                    scale = item.unmodified_size.split(',')[1]
                }
                return {
                    ...item, srcColumnName: item.unmodified_name, srcDataType: item.unmodified_type ? item.unmodified_type : item.unmodified_type[0], srcMaxLength: item.unmodified_size ? (item.unmodified_size.includes(',') ? "" : item.unmodified_size) : "",
                    srcPrecision: precision, srcScale: scale, synPrecision: precision, synScale: scale,
                    synColumnName: item.name, synDataType: item.type ? item.type : item.type[0], synMaxLength: item.size ? item.size : (item.unmodified_size ? (item.unmodified_size.includes(',') ? "" : item.unmodified_size) : 0), treatmentLevel: 'Low', securityClassification: 'General Business', privacyClassification: 'None', id: index, srcOrdinal: index
                };
            });
            setColumnGovernance(newRows)

        }
        catch (e) {
            alert('Please check the format')
        }

    }

    // generate column governance fields
    useEffect(() => {
        if (extractorTableData[table_name]) {
            const newRows = extractorTableData[table_name]?.map((item: any, index: number) => {
                return {
                    ...item, treatmentLevel: 'low',
                    securityClassification: dataSourceData?.securityClassification.fieldValue && dataSourceData?.securityClassification.fieldValue !== " " ? getSecurityClassificationText(dataSourceData.securityClassification.fieldValue) : 'General Business',
                    privacyClassification: dataSourceData?.privacyClassification.fieldValue && dataSourceData?.privacyClassification.fieldValue !== " " ? getPrivacyClassificationText(dataSourceData.privacyClassification.fieldValue) : 'None', id: index
                };
            });
            setColumnGovernance(newRows)
        }
    }, [extractorTableData]);

    //Generate Column Governance for Foundry
    useEffect(() => {
        if (foundryMetaData.length > 0) {
            const newRows = foundryMetaData?.map((item: any, index: number) => {
                return {
                    ...item, treatmentLevel: 'low',
                    securityClassification: dataSourceData?.securityClassification.fieldValue && dataSourceData?.securityClassification.fieldValue !== " " ? getSecurityClassificationText(dataSourceData.securityClassification.fieldValue) : 'General Business',
                    privacyClassification: dataSourceData?.privacyClassification.fieldValue && dataSourceData?.privacyClassification.fieldValue !== " " ? getPrivacyClassificationText(dataSourceData.privacyClassification.fieldValue) : 'None', id: index
                };
            });
            setColumnGovernance(newRows);
        }
    }, [foundryMetaData])

    // add hstg column - Needed for commercial spoke - governance views
    // useEffect(() => {
    //     if (extractorTableData[table_name]) {
    //         const prefix = "UDL"
    //         const prefixSource = dataSourceData?.name.fieldValue ? prefix.concat(dataSourceData?.name.fieldValue) : ''
    //         const layerName: string = dataSourceData?.name.fieldValue.substring(0, 3) === "UDL" ? dataSourceData?.name.fieldValue : prefixSource
    //         const getTableName = configureTablesData.dataSetName.fieldValue
    //         setColumnGovernance((state: any) => [...state, {
    //             "id": "0",
    //             "srcColumnName": `HSTG_${layerName.concat("_" + configureTablesData.schemaName.fieldValue + "_" + getTableName)}_SK`,
    //             "srcDataType": "varchar",
    //             "srcMaxLength": -1,
    //             "srcOrdinal": 0,
    //             "srcPrecision": 0,
    //             "srcScale": 0,
    //             "synColumnName": `HSTG_${layerName.concat("_" + configureTablesData.schemaName.fieldValue + "_" + getTableName)}_SK`,
    //             "synDataType": "VARCHAR",
    //             "synMaxLength": "100",
    //             "synOrdinal": "0",
    //             "synPrecision": "",
    //             "synScale": "",
    //             "treatmentLevel": 'low',
    //             "privacyClassification": "none",
    //             "securityClassification": "general"
    //         }])
    //     }

    // }, [extractorTableData]);



    // handle text field changes
    const handleCommit = (e: GridCellEditCommitParams) => {
        const array = columnGovernance.map((row: any) => {
            if (row.id === e.id) {
                return { ...row, [e.field]: e.value };
            } else {
                return { ...row };
            }
        });
        setColumnGovernance(array);
    };

    // onchange for data stewards
    const updateDataStewardGroup = (event: SelectChangeEvent<string>) => {
        let value: string = event.target.value;
        setDataStewardGroup(value);
        setChanges(true)

    };

    // set pending when add set button clicked
    const pending = useSelector(extractorDBData.postDBExtPendingSelector)
    // S3pending name changed to Custom Extractor pending
    const custExtpending = useSelector(extractorDBData.postCustExtPendingSelector)


    //error validation for dropdowns

    const [error, setError] = useState(false)
    const [required, setRequired] = useState(true)
    const [errorMsg, setErrorMsg] = useState('Field is required');


    const onHandleBlur = (event: {}) => {
        const e = event as React.FocusEvent<HTMLInputElement>;
        ((e.target.value === "" || !e.target.value) && (required)) ? setError(true) : setError(false);
    }

    const errorStyle = {
        color: '#d32f2f',
        fontSize: 'small',
        paddingTop: '1em'
    }
    // onchange for textfields
    const handleChange = (event: {}) => {
        const e = event as React.ChangeEvent<HTMLInputElement>;
        let field: IFormField = {

            fieldValue: e.currentTarget.value,
            isError: false,
            errorMsg: '',
            isNumber: false,
        };

        setConfigureTablesData({ ...configureTablesData, [e.target.name]: field });
        setChanges(true)

    }

    const cascadeFieldSecurity = (security: string, privacy: string) => {
        let treatmentLevel = 'low'

        if (security === 'highly_confidential') {
            treatmentLevel = 'high'
        } else if (security === 'confidential') {
            if (privacy === 'none') {
                treatmentLevel = 'medium'
            } else if (privacy === 'personal') {
                treatmentLevel = 'high'
            } else if (privacy === 'sensitive') {
                treatmentLevel = 'very-high'
            }
        }

        security = getSecurityClassificationText(security)!;
        privacy = getPrivacyClassificationText(privacy)!

        const array = columnGovernance?.map((row: any) => {
            return { ...row, treatmentLevel: treatmentLevel, securityClassification: security, privacyClassification: privacy }
        });

        setColumnGovernance(array);
    }

    //security / privacy classification
    const updateSecurityDropdown = (event: SelectChangeEvent<string>) => {

        let value: string = event.target.value;

        if (value !== 'confidential') {
            setDisablePrivacy(false);
            setConfigureTablesData({ ...configureTablesData, [event.target.name]: functions.getFormField(value), privacyClassification: functions.getFormField('none') });
            cascadeFieldSecurity(value, 'none')
        } else {
            setDisablePrivacy(true);
            setConfigureTablesData({ ...configureTablesData, [event.target.name]: functions.getFormField(value) });
            cascadeFieldSecurity(value, configureTablesData.privacyClassification.fieldValue)
        }
        setChanges(true)

    };

    const updatePrivacyDropdown = (event: SelectChangeEvent<string>) => {

        let value: string = event.target.value;

        setConfigureTablesData({ ...configureTablesData, [event.target.name]: functions.getFormField(value) });

        cascadeFieldSecurity(configureTablesData.securityClassification.fieldValue, value)

    };

    const onDropdownChange = (e: SelectChangeEvent<string>) => {

        setConfigureTablesData({ ...configureTablesData, [e.target.name]: functions.getFormField(e.target.value) });
        setChanges(true)
    };

    const viewSource = (event: React.MouseEvent<HTMLButtonElement>) => {
        const url = `/ViewDataSource/${sourceId}`;
        if (event.ctrlKey) {
            window.open(url, '_blank')
        }
        else {
            navigate(url);
        }
    }

    // onchange for dropdown
    const handleDropDownChange = (e: SelectChangeEvent<string>) => {
        let field: IFormDropDown = {
            fieldValue: e.target.value,
            isError: false,
            errorMsg: '',
        };

        setConfigureTablesData({ ...configureTablesData, [e.target.name]: field });
        setChanges(true)

    }

    // onchange for trigger
    const onTriggerChange = (inputTrigger: triggerTypeList) => {
        const newTriggers = triggers.map((item) => {
            if (item.key === inputTrigger.key) return inputTrigger;
            return item;
        })
        setTriggers(newTriggers)
    }

    // add new trigger
    const addTrigger = () => {
        setTriggers(
            triggers.concat({
                key: Date.now()
            })
        )
    }

    // delete trigger
    const deleteTrigger = (id: number) => {
        const triggerItem = triggers.filter((item) => item.key !== id)
        setTriggers(triggerItem)

    }

    // onchange for action
    const onActionChange = (inputAction: actionTypeList) => {
        const newActions = actions.map((item) => {
            if (item.key === inputAction.key) return inputAction;
            return item;
        })
        setActions(newActions)
        setChanges(true)
    }

    // add new action
    const addAction = () => {
        setActions(
            actions.concat({
                key: Date.now()
            })
        )
    }

    // delete action
    const deleteAction = (id: number) => {
        const actionItem = actions.filter((item) => item.key !== id)
        setActions(actionItem)

    }

    //editExtractor
    const editExtractor = (event: React.MouseEvent<HTMLButtonElement>) => {
        const url = `/EditDataExtractor/${batchCode}`;
        if (event.ctrlKey) {
            window.open(url, '_blank')
        }
        else {
            navigate(url);
        }
    };

    const handleClose = () => {
        setOpenConfirmationDialog(false)
    }

    const deleteParams: IDeleteParams = {
        batchCodes: [batchCode!],
    };

    const deleteExtractor = () => {
        dispatch(deleteExtractorReq(deleteParams));
        navigate(`/DataExtractorList`);
    };

    const loaderListParams: ISearchParam = {
        skip: 0,
        top: 1,
        count: true,
        orderby: `description asc`,
        search: batchCode
    };

    // to navigate View Extractor
    const viewextractor = (data: any) => {
        navigate(`/ViewDataExtractor/${data[0].batchCode}`);
        dispatch(dbExtractor.postCustomExtReset());
        dispatch(dbExtractor.postDBExtReset());
        setChanges(false)
    }

    const viewExtractorList = () => {
        navigate(`/DataExtractorList`);
    }

    const viewLoaders = (event: React.MouseEvent<HTMLButtonElement>) => {
        const url = `/DataLoaderList/ExtractorBatchCode/${batchCode}`;
        if (event.ctrlKey) {
            window.open(url, '_blank')
        }
        else {
            navigate(url);
        }
    };

    //request Access
    const requestAccess = () => {

        window.open('https://riotinto.service-now.com/esc?id=sc_cat_item&sys_id=36d0848487c4b1d0f38c64673cbb35fe')
    };

    // Validating individual form UI on the accordion on clicking Validate
    const validateForm = () => {
        //first check if amazon s3 form fields are empty
        if (connection === "S3 Buckets" || connection === "Windows Fileshare" || connection === constants.CONNECTION_TYPES.azure) {
            if (!configureTablesData.schemaName.fieldValue ||
                !configureTablesData.dataSetName.fieldValue ||
                columnGovernance.length < 1)
                return alert("Please make sure to fill required fields in table " + tableName)
        }

        if (connection === "Foundry") {
            configureTablesData.schemaName.fieldValue = "master";
        }

        if (props.customSQL) {
            if (!configureTablesData.customsql.fieldValue)
                return alert("Please make sure to add custom sql query")
        }
        // then check if other form fields are empty
        if (!configureTablesData.name.fieldValue || !configureTablesData.description.fieldValue ||
            !configureTablesData.schemaName.fieldValue || !configureTablesData.privacyClassification.fieldValue
            || !configureTablesData.securityClassification.fieldValue
        ) {
            // set error list if validation failed
            const tName = tableName ? tableName : ""
            props.setErrorList((current: any) => ({
                ...current,
                [tName]: {
                    error: true,
                }
            }));



            alert("Please make sure to fill required fields in table " + tableName)
        }
        else {
            // make sure to set error false if validation succeeded
            const tName = tableName ? tableName : ""
            props.setErrorList((current: any) => ({
                ...current,
                [tName]: {
                    error: false,
                }
            }));

            const dataSteward = dataStewardIDs.map(({ userName }) => `${userName}`).join(', ');
            const database = dataSourceData?.database.fieldValue
            const prefix = "UDL"
            const prefixSource = dataSourceData?.name.fieldValue ? prefix.concat(dataSourceData?.name.fieldValue) : ''
            const layerName = dataSourceData?.name.fieldValue.substring(0, 3) === "UDL" ? dataSourceData?.name.fieldValue : prefixSource

            const getTableName = connection === "S3 Buckets" || connection === "Windows Fileshare" || props.customSQL || connection === constants.CONNECTION_TYPES.azure || connection === constants.CONNECTION_TYPES.foundry ? configureTablesData.dataSetName.fieldValue : tableName

            columnGovernance.map((x: { securityClassification: string | undefined; }) => { x.securityClassification = getSecurityPayloadText(x.securityClassification!) });
            columnGovernance.map((x: { privacyClassification: string | undefined; }) => { x.privacyClassification = getPrivacyPayloadText(x.privacyClassification!) });

            let tableData = {
                configureTablesData,
                getTableName,
                columnGovernance,
                extract,
                history,
                staging,
                landing,
                accessControlGroup,
                dataSteward,
                triggers,
                actions,
                tableIndex,
                connection,
                comparisonKey,
                sourceID,
                database,
                layerType,
                layerName,
                spokeName
            }
            submitTablesData(tableData)
            setProcessingExtractor(true)
            setChanges(false)
        }

    }

    useEffect(() => {
        setDisplayTriggers(true);
    }, [displayTriggers]);

    useEffect(() => {
        setDisplayActions(true);
    }, [displayActions]);

    useEffect(() => {
        setDisplayTriggers(false);
        setDisplayActions(false);
    }, []);

    const checkAccess = () => {
        const getAccessResult: any = []
        if (profile && profile.length && accessControlGroup && accessControlGroup.length) {
            accessControlGroup.map((x) => {
                return profile.map((y) => { return getAccessResult.push(y.adGroupName.toLowerCase() === x.toLowerCase()); })
            })
        }

        // check if any value has been returned as true, if there is a match (indicated by true) then return display button as false else display true
        return getAccessResult.some(Boolean);
    }

    const checkGrantee = () => {
        let granteeList: any = [];
        let getGranteeResult: any = [];

        if (!extractorList.hasOwnProperty('extractors') || extractorList.extractors.length < 1) {
            return false;
        }

        let grantees = extractorList.extractors[0].grantees;

        if (grantees) {
            let splitIDs = grantees.split(",").filter((x) => x !== "");

            splitIDs.forEach(function (value) {
                granteeList.push(value);
            });

            //Override can be granted to single user or AD Group
            if (profile && granteeList) {
                granteeList.map((x: string) => {
                    if (x.includes('@riotinto.com')) {
                        return profile.map((y) => { return getGranteeResult.push(y.userName.toLowerCase() === x.toLowerCase()); })
                    }
                    else {
                        return profile.map((y) => { return getGranteeResult.push(y.adGroupName.toLowerCase() === x.toLowerCase()); })
                    }
                })
            }
        }
        return getGranteeResult.some(Boolean);
    }

    /*****SUBSCRIPTION *****/

    //Subcription Logic
    useEffect(() => {
        setSubscriptionPending(subscriptionPendingList)
    }, [subscriptionPendingList]);


    useEffect(() => {
        window.scrollTo(0, 0);

        if (authProfile !== null && authProfile !== undefined && batchCode) {
            const ownerValue = authProfile!["userPrincipalName"];
            if (ownerValue && mode === constants.MODE.view) {
                const params: ISubscriptionSearchParams = {
                    batchCode: batchCode,
                    subscriber: ownerValue
                };
                dispatch(fetchSubscriptionRequest(params));
            }
        }
    }, [authProfile, batchCode]);

    const subscriptionClicked = () => {
        if (batchCode) {
            const subscriptionPayload = {
                "subscriber": authProfile?.mail,
                "description": configureTablesData.description.fieldValue,
            }
            dispatch(postExtractorSubscriptionRequest(batchCode, subscriptionPayload));
        }
    };

    // if subscription is successful
    useEffect(() => {
        if (postExtractorSubscriptionSuccess?.subscriptionId) {
            setSubscribed(true);
            setSubscriptionId(postExtractorSubscriptionSuccess?.subscriptionId)
        }
    }, [postExtractorSubscriptionSuccess]);

    // if subscription deleted successfully
    useEffect(() => {

        if (deleteSubscriptionSuccess?.isSuccess) {
            setSubscribed(false);
        }
    }, [deleteSubscriptionSuccess]);

    const subscriptionDeleted = () => {
        dispatch(deleteSubscriptionReq(subscriptionId, "extractor"));
    };

    // has the user subscribed to this Extractor
    useEffect(() => {
        if (!subscriptionPendingList && subscriptionList && subscriptionList.length > 0 && subscriptionList[0].enabled) {
            setSubscriptionId(subscriptionList[0].subscriptionId)
            setSubscribed(true)
        } else {
            setSubscribed(false)
        }
    }, [subscriptionList, subscriptionPendingList]);

    // ******** END SUBSCRIPTION ***********

    return (

        <Formik
            initialValues={{}}
            onSubmit={() => { }} >
            <div>
                <Stack direction="row" spacing={1}>
                    <Button id="4ba65f8b-3135-4b2f-8022-0c021b862943" aria-label="delete" onClick={goBack} startIcon={<ArrowBackIosNewIcon />}>
                        Extractor List
                    </Button>
                </Stack>
                <Grid container>
                    <Grid item xs={6}>
                        <h1>{tableName && tableName} {mode !== "Add" ? 'Data Extractor Properties' : ''}
                            &nbsp;
                            {!taskDisabled && mode === constants.MODE.view ? <Tooltip title="Inactive">
                                <WarningAmberRoundedIcon fontSize="medium" />
                            </Tooltip> : null}
                        </h1>
                    </Grid>
                    <Grid item xs={6}>
                        <Box display="flex" justifyContent="flex-end" m={2}>
                            {loadingExtractorDetail || subscriptionPending ? <LoadingButton loading loadingPosition="start" style={{ marginTop: '1em' }} variant="outlined" size="small" startIcon={<SaveIcon />} > Loading </LoadingButton>
                                :
                                <>
                                    {!subscribed ?
                                        <Button id="3621ffdc-cb22-4825-88ff-8fcf2119a5ec"
                                            startIcon={<NotificationsIcon />}
                                            color="primary"
                                            variant="contained"
                                            onClick={subscriptionClicked}
                                            style={{ marginRight: "1em" }}
                                        >
                                            Subscribe
                                        </Button> : ''}
                                    {subscribed ?
                                        <Button id="e5d5cc87-5296-4543-b1f4-fdc8092b5253"
                                            startIcon={<NotificationsActiveIcon />}
                                            color="inherit"
                                            variant="contained"
                                            onClick={subscriptionDeleted}
                                            style={{ marginRight: "1em" }}
                                        >
                                            Subscribed
                                        </Button>
                                        : ''
                                    }
                                </>
                            }
                        </Box>
                    </Grid>
                </Grid>
                <Form>
                    {/* adding skeleton screen on loading */}
                    {mode === "View" && loadingExtractorDetail ?
                        <Box>
                            <Grid container spacing={4} >
                                <Grid item xs={6}>
                                    <Skeleton animation="wave" height={60} />
                                </Grid>
                                <Grid item xs={6}>
                                    <Skeleton animation="wave" height={60} />
                                </Grid>
                                <Grid item xs={4}>
                                    <Skeleton animation="wave" height={60} />
                                </Grid>
                                <Grid item xs={4}>
                                    <Skeleton animation="wave" height={60} />
                                </Grid>
                                <Grid item xs={4}>
                                    <Skeleton animation="wave" height={60} />
                                </Grid>
                                <Grid item xs={6}>
                                    <Skeleton animation="wave" height={60} />
                                </Grid>
                                <Grid item xs={6}>
                                    <Skeleton animation="wave" height={60} />
                                </Grid>
                                <Grid item xs={12}>
                                    <Skeleton animation="wave" height={60} />
                                </Grid>
                                <Grid item xs={6}>
                                    <Skeleton animation="wave" height={60} />
                                </Grid>
                                <Grid item xs={6}>
                                    <Skeleton animation="wave" height={60} />
                                </Grid>
                                <Grid item xs={6}>
                                    <Skeleton animation="wave" height={60} />
                                </Grid>
                                <Grid item xs={6}>
                                    <Skeleton animation="wave" height={60} />
                                </Grid>
                            </Grid>

                        </Box> :
                        <Grid container spacing={4}>
                            {/* Display request access button only if
                            1 - The user hasn't created the extractor
                            2 - Treatment Level is above low
                            3 - If there are access controls  */}
                            {/* Note: Logic needs to be defined for access controls and treatments */}
                            {mode === "View" && isAdmin ?
                                <>
                                    {(checkAccess() === false && checkGrantee() === false)
                                        ?
                                        <Grid item xs={12}>
                                            <h2>Request Access</h2>
                                            <p>  You are able to request to remove restrictions on this Data Set if you have a valid reason. Click the 'Request Access' button to be directed to RTTMS and complete the form.
                                                When filling out this form, please include all technical information that will assist with processing this request - this should include the current data set name and/or URL, as well as a valid business reason for requesting this access.
                                            </p>
                                            <Button id="8e740b46-d9c7-4e06-9266-7d46adfb27ba" color="primary" variant="contained" onClick={requestAccess}>
                                                Request Access</Button>
                                        </Grid>
                                        : ''
                                    }
                                </>
                                : ''}
                            <Grid item xs={5}>
                                <FormControl sx={{ m: 1 }} fullWidth variant={(mode === constants.MODE.view) ? "standard" : "outlined"}>
                                    <DataField id="39cc285f-23d3-4869-9316-fe19c08b804c"
                                        label='Name'
                                        name='name'
                                        required={true}
                                        value={configureTablesData.name.fieldValue}
                                        error={configureTablesData.name.isError}
                                        onChange={handleChange}
                                        disabled={mode === "View" ? true : false}
                                        readOnly={(mode === constants.MODE.view) ? true : false}
                                    />
                                </FormControl>
                            </Grid>

                            <Grid item xs={7}>
                                <FormControl sx={{ m: 1 }} fullWidth variant={(mode === constants.MODE.view) ? "standard" : "outlined"}>
                                    <DataField id="17e2586d-806c-4b62-922d-babd299a0b80"
                                        type='textarea'
                                        name='description'
                                        label="Description"
                                        required={true}
                                        value={configureTablesData.description.fieldValue}
                                        error={configureTablesData.description.isError}
                                        onChange={handleChange}
                                        multiline={true}
                                        disabled={mode === "View" ? true : false}
                                        readOnly={(mode === constants.MODE.view) ? true : false}
                                    />
                                </FormControl>
                            </Grid>
                            {connection === "S3 Buckets" || connection === "Windows Fileshare" || connection === constants.CONNECTION_TYPES.azure ?
                                <>
                                    <Grid item xs={3}>
                                        <FormControl sx={{ m: 1 }} fullWidth variant={(mode === constants.MODE.view) ? "standard" : "outlined"}>
                                            <DataField id="024da60f-01d8-40fd-926b-298895482be4"
                                                label={connection === constants.CONNECTION_TYPES.azure ? 'Dataset Folder Name' : 'Folder Name'}
                                                name='schemaName'
                                                value={configureTablesData.schemaName.fieldValue}
                                                error={configureTablesData.schemaName.isError}
                                                infoText={connection === "S3 Buckets" ? "Please ensure that the bucket and folder paths you are creating are unique (i.e. do not create multiple extractors with the same bucket / folder path as this will overwrite the data)" : ""}
                                                onChange={handleChange}
                                                required={true}
                                                readOnly={(mode === constants.MODE.view) ? true : false}
                                            />
                                        </FormControl> </Grid>
                                </> :
                                <>
                                    {/* {connection !== "Foundry" ? */}
                                    <Grid item xs={3}>
                                        <FormControl sx={{ m: 1 }} fullWidth variant={(mode === constants.MODE.view) ? "standard" : "outlined"}>
                                            <DataField id="7f3edc33-2907-4c75-8f52-607b332585f3"
                                                name='schemaName'
                                                label={connection === "S3 Buckets" || layerType === "EXTRACT_S3" || layerType === constants.EXTRACT_TYPES.adls ? layerType === constants.EXTRACT_TYPES.adls ? 'Dataset Folder Name' : 'Folder Name' : 'Schema Name'}
                                                value={configureTablesData.schemaName.fieldValue}
                                                disabled={props.customSQL ? false : true}
                                                error={configureTablesData.schemaName.isError}
                                                onChange={handleChange}
                                                required={true}
                                                readOnly={(mode === constants.MODE.view) ? true : false}
                                            />
                                        </FormControl> </Grid>
                                    {/* : <></>
                                    } */}
                                </>
                            }
                            <Grid item xs={3}>
                                <FormControl sx={{ m: 1 }} fullWidth variant={(mode === constants.MODE.view) ? "standard" : "outlined"}>
                                    <DataField id="60b4ea17-2f40-4992-bcd9-cb61dbc2a6a7"
                                        label={connection === "S3 Buckets" || layerType === "EXTRACT_S3" || layerType === constants.EXTRACT_TYPES.adls ? layerType === constants.EXTRACT_TYPES.adls ? 'File Name Prefix' : 'File Name' : 'Data Set Name'}
                                        name='dataSetName'
                                        value={configureTablesData.dataSetName.fieldValue}
                                        error={configureTablesData.dataSetName.isError}
                                        onChange={handleChange}
                                        required={true}
                                        disabled={connection === "S3 Buckets" || props.customSQL || connection === "Windows Fileshare" || connection === constants.CONNECTION_TYPES.azure || layerType === constants.EXTRACT_TYPES.adls ? false : true}
                                        infoText={connection === "S3 Buckets" ? "Note: Source name will be prefixed to the dataset name entered" : ""}
                                        readOnly={(mode === constants.MODE.view) ? true : false}
                                    />
                                </FormControl>
                            </Grid>

                            <Grid item xs={6}>
                                <FormControl sx={{ m: 1 }} fullWidth variant={(mode === constants.MODE.view) ? "standard" : "outlined"}>
                                    <InputLabel htmlFor="accessControls">Access Controls</InputLabel>
                                    <Select
                                        name='accessControls'
                                        label='Access Controls'
                                        multiple
                                        value={accessControlGroup.map(value => value.toLowerCase())}
                                        onChange={(event) => {
                                            let v = event.target.value as string[];
                                            setAccessControlGroup(v);
                                        }}
                                        labelId='accessControlslabel'
                                        fullWidth
                                        variant={mode === "View" ? "standard" : "outlined"}
                                        required
                                        disabled={mode === "View" ? true : false}
                                        sx={{ textAlign: 'left' }}
                                    >{
                                            accessControls.map((item: IAccessControl, index: number, items: IAccessControl[]) => {
                                                return (
                                                    <MenuItem key={index} value={item.groupName.toLowerCase()}>{item.groupName}</MenuItem>
                                                );
                                            })
                                        }

                                    </Select>
                                </FormControl>
                            </Grid>
                            {mode === "View" ? '' :
                                <Grid item xs={6}>
                                    <FormControl sx={{ m: 1 }} fullWidth variant={(mode === constants.MODE.view) ? "standard" : "outlined"}>
                                        <InputLabel htmlFor="dataStewardADlabel">Data Stewards Group</InputLabel>
                                        <Select
                                            name='dataStewardsAD'
                                            onChange={updateDataStewardGroup}
                                            label='Data Stewards'
                                            labelId='dataStewardADlabel'
                                            fullWidth
                                            variant={mode === "View" ? "standard" : "outlined"}
                                            disabled={mode === "View" ? true : false}
                                            value={dataStewardGroup.toLowerCase()}
                                            sx={{ textAlign: 'left' }}
                                        >{
                                                accessControls.map((item: IAccessControl, index: number, items: IAccessControl[]) => {
                                                    return (
                                                        <MenuItem key={index} value={item.groupName.toLowerCase()}>{item.groupName}</MenuItem>
                                                    );
                                                })
                                            }
                                        </Select>
                                    </FormControl>
                                </Grid>
                            }
                            {mode === "View" ?
                                <Grid item xs={4}>
                                    <FormControl sx={{ m: 1 }} fullWidth variant={(mode === constants.MODE.view) ? "standard" : "outlined"}>
                                        {stewards && <DataField id="d9557a03-1a15-40e2-8f4e-f6f88716b874"
                                            label="Data Stewards"
                                            name="dataStewards"
                                            value={stewards}
                                            disabled={true}
                                            type="textarea"
                                            multiline={true}
                                            readOnly={
                                                mode === constants.MODE.view ? true : false
                                            }
                                            rows={mode === constants.MODE.view ? 1 : 5}
                                        />}
                                    </FormControl>
                                </Grid> :
                                <Grid item xs={6}>
                                    <FormControl sx={{ m: 1 }} fullWidth variant={(mode === constants.MODE.view) ? "standard" : "outlined"}>
                                        <Autocomplete
                                            multiple
                                            options={stewardData}
                                            onChange={(event, value) => {
                                                let v = value as IUser[];
                                                setDataStewardIDs(v);
                                            }}
                                            getOptionLabel={(option) =>
                                                option === undefined ? "" : option.userName
                                            }
                                            value={dataStewardIDs}
                                            isOptionEqualToValue={(option, value) =>
                                                option.userName === value.userName
                                            }
                                            renderInput={(params) => (
                                                <TextField {...params}
                                                    name="Data Stewards"
                                                    label="Data Stewards"
                                                    required
                                                    value={dataStewardIDs}
                                                    error={configureTablesData.dataStewards.isError}
                                                />

                                            )}
                                        />
                                    </FormControl>
                                </Grid>
                            }
                            <Grid item xs={4}>
                                <FormControl sx={{ m: 1 }} variant={(mode === constants.MODE.view) ? "standard" : "outlined"} fullWidth required={required} error={error}>
                                    <InputLabel htmlFor='securityClassification'>Security Classification</InputLabel>
                                    <Select
                                        id='securityClassification'
                                        name='securityClassification'
                                        labelId='securityClassification'
                                        label='Security Classification'
                                        disabled={mode === "View" ? true : false}
                                        value={configureTablesData.securityClassification.fieldValue}
                                        onChange={updateSecurityDropdown}
                                        sx={{ textAlign: 'left' }}
                                        onBlur={onHandleBlur}
                                        variant={mode === "View" ? "standard" : "outlined"}
                                        fullWidth
                                    >
                                        <MenuItem key={0} value={constants.SECURITY_CLASS_VALUES.general}>{constants.SECURITY_CLASS.general}</MenuItem>
                                        <MenuItem key={1} value={constants.SECURITY_CLASS_VALUES.confidential}>{constants.SECURITY_CLASS.confidential}</MenuItem>
                                        <MenuItem key={2} value={constants.SECURITY_CLASS_VALUES.highlyConfidential}>{constants.SECURITY_CLASS.highlyConfidential}</MenuItem>
                                        {mode === "View" ? <MenuItem value={configureTablesData.securityClassification.fieldValue}>{configureTablesData.securityClassification.fieldValue}</MenuItem> : ''}
                                    </Select>
                                    <span style={errorStyle}>{error ? errorMsg : ''}</span>

                                </FormControl>
                            </Grid>
                            <Grid item xs={4}>
                                <FormControl sx={{ m: 1 }} fullWidth variant={(mode === constants.MODE.view) ? "standard" : "outlined"} required={required} error={error}>
                                    <InputLabel htmlFor='privacyClassification'>Privacy Classification</InputLabel>
                                    <Select
                                        id='privacyClassification'
                                        name='privacyClassification'
                                        label='Privacy Classification'
                                        labelId='privacyClassification'
                                        value={configureTablesData.privacyClassification.fieldValue}
                                        onChange={updatePrivacyDropdown}
                                        onBlur={onHandleBlur}
                                        sx={{ textAlign: 'left' }}
                                        variant={mode === "View" ? "standard" : "outlined"}
                                        disabled={mode === "View" ? true : false}
                                        fullWidth
                                    >
                                        <MenuItem key={0} value={constants.PRIVACY_CLASS_VALUES.none}>{constants.PRIVACY_CLASS.none}</MenuItem>
                                        {disablePrivacy && <MenuItem key={1} value={constants.PRIVACY_CLASS_VALUES.personal}>{constants.PRIVACY_CLASS.personal}</MenuItem>}
                                        {disablePrivacy && <MenuItem key={2} value={constants.PRIVACY_CLASS_VALUES.sensitive}>{constants.PRIVACY_CLASS.sensitive}</MenuItem>}
                                        {mode === "View" ? <MenuItem value={configureTablesData.privacyClassification.fieldValue}>{configureTablesData.privacyClassification.fieldValue}</MenuItem> : ''}


                                    </Select>
                                    <span style={errorStyle}>{error ? errorMsg : ''}</span>

                                </FormControl>
                            </Grid>

                            {mode === "View" ?
                                <Grid item xs={4} >
                                    <FormControl
                                        sx={{ m: 1 }}
                                        fullWidth
                                        disabled={true}
                                        variant={
                                            mode === constants.MODE.view ? "standard" : "outlined"
                                        }
                                        required
                                    >
                                        <InputLabel id="demo-simple-select-label">Criticality</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="criticality-simple-select"
                                            label="Criticality"
                                            name="criticality"
                                            autoWidth
                                            value={extractorDetail?.criticality}
                                        >
                                            {constants.criticalities.map((item, index) => {
                                                return (
                                                    <MenuItem
                                                        value={item.value}
                                                        key={index}
                                                        sx={{ borderTop: 1, borderColor: "grey.400" }}
                                                    >
                                                        <ListItemText
                                                            primary={item.title}
                                                            secondary={
                                                                <>
                                                                    {item.application}
                                                                    <br />
                                                                    {item.availability}
                                                                    <br />
                                                                    {item.upTime}
                                                                </>
                                                            }
                                                        />
                                                    </MenuItem>
                                                );
                                            })}
                                        </Select>
                                    </FormControl>
                                </Grid> : ''}

                            <Grid item xs={12}>
                                <h2>Patterns</h2>
                                <p style={{ color: 'red' }}>   {mode === "Add" && patterns && patterns.EXT === undefined ? '' : ''}
                                </p>
                            </Grid>

                            {(mode === "Add" || mode === "View") && patterns && <><Grid item xs={4}>
                                <FormControl sx={{ m: 1 }} fullWidth
                                    variant={(mode === constants.MODE.view) ? "standard" : "outlined"}>
                                    <InputLabel htmlFor='extract'>Extract</InputLabel>
                                    <Select
                                        name='extract'
                                        label='Extract'
                                        value={extract}
                                        onChange={(event) => {
                                            let v = event.target.value;
                                            setExtract(v);
                                        }}
                                        labelId='extractLabel'
                                        fullWidth
                                        disabled={mode === "View" ? true : false}
                                        onBlur={onHandleBlur}
                                        sx={{ textAlign: 'left' }}
                                    >
                                        {
                                            mode === "Add" ? patterns.EXT !== undefined && connection !== constants.CONNECTION_TYPES.azure && patterns?.EXT.filter((item: IExtractorPatterns, index: number) => {
                                                if (props.customSQL) {
                                                    return item.patternName.includes("CustomSQL")
                                                }
                                                else if (connection === "S3 Buckets" || layerType === "EXTRACT_S3") { return item.patternName.includes("ADB S3") }
                                                else return !item.patternName.includes("CustomSQL")
                                            }).map((item: IExtractorPatterns, index: number, items: IExtractorPatterns[]) => {
                                                return (
                                                    <MenuItem key={index} value={item.etlPatternId}>{item.patternName}</MenuItem>
                                                );
                                            }) // adding the else condition so that it doesn't affect displaying patterns on existing extractors. can be removed after a while
                                                : patterns.EXT !== undefined && patterns?.EXT.map((item: IExtractorPatterns, index: number, items: IExtractorPatterns[]) => {
                                                    return (
                                                        <MenuItem key={index} value={item.etlPatternId}>{item.patternName}</MenuItem>
                                                    );
                                                })
                                        }
                                        <MenuItem value="-1" selected>None</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                                {layerType !== constants.EXTRACT_TYPES.foundry ?
                                    <Grid item xs={4}>
                                        <FormControl sx={{ m: 1 }} fullWidth variant={(mode === constants.MODE.view) ? "standard" : "outlined"}>
                                            <InputLabel htmlFor='landing'>Landing</InputLabel>
                                            <Select
                                                name='landing'
                                                label='Landing'
                                                value={landing}
                                                onChange={(event) => {
                                                    let v = event.target.value;
                                                    setLanding(v);
                                                }}
                                                labelId='landingLabel'
                                                fullWidth
                                                disabled={mode === "View" ? true : false}
                                                onBlur={onHandleBlur}
                                                //required
                                                sx={{ textAlign: 'left' }}
                                            >{
                                                    patterns.LND !== undefined &&
                                                    patterns?.LND.filter(
                                                        (item: IExtractorPatterns, index: number) => {
                                                            if (connection === constants.CONNECTION_TYPES.azure) {
                                                                return (item.patternName.includes("RIO-LND ADLS CSV to Synapse")
                                                                    &&
                                                                    !item.patternName.includes("RIO-LND ADLS to ADF Synapse Copy"));
                                                            } else return !item.patternName.includes("RIO-LND ADLS to ADF Synapse Copy");
                                                        }
                                                    ).map((item: IExtractorPatterns, index: number, items: IExtractorPatterns[]) => {
                                                        return (
                                                            <MenuItem key={index} value={item.etlPatternId}>{item.patternName}</MenuItem>
                                                        );
                                                    })
                                                }
                                                <MenuItem value="-1" selected>None</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    : <></>
                                }
                                <Grid item xs={4}>
                                    <FormControl sx={{ m: 1 }} fullWidth
                                        variant={(mode === constants.MODE.view) ? "standard" : "outlined"}>
                                        <InputLabel htmlFor='history'>History</InputLabel>
                                        <Select
                                            name='history'
                                            label='history'
                                            disabled={mode === "View" ? true : false}
                                            value={history}
                                            onChange={(event) => {
                                                let v = event.target.value;
                                                setHistory(v);
                                            }}
                                            labelId='historyLabel'
                                            fullWidth
                                            onBlur={onHandleBlur}
                                            required
                                            sx={{ textAlign: 'left' }}
                                        >{
                                                mode === "Add" ? patterns.HSTG !== undefined && patterns?.HSTG.filter((item: IExtractorPatterns, index: number) => {
                                                    if (connection === "S3 Buckets" || layerType === "EXTRACT_S3") { return item.patternName.includes("S3") }
                                                    else if (connection === constants.CONNECTION_TYPES.azure) {
                                                        var azurePatterns = ["ADLS", "RIO-HSTG ADF Synapse Comparison Key"];
                                                        return azurePatterns.some(x => item.patternName.includes(x));
                                                    }
                                                    else if (connection === constants.CONNECTION_TYPES.foundry) {
                                                        return item.patternName.includes("Foundry");
                                                    }
                                                    // else if (connection === "Windows Fileshare" || layerType === "EXTRACT_WFS") { return item.patternName.includes("ADF ADLS") }
                                                    else return item.patternName.includes("ADF Synapse")
                                                }).map((item: IExtractorPatterns, index: number, items: IExtractorPatterns[]) => {
                                                    return (
                                                        <MenuItem key={index} value={item.etlPatternId}>{item.patternName}</MenuItem>
                                                    );
                                                }) // adding the else condition so that it doesn't affect displaying patterns on existing extractors. can be removed after a while
                                                    : patterns.HSTG !== undefined && patterns?.HSTG.map((item: IExtractorPatterns, index: number, items: IExtractorPatterns[]) => {
                                                        return (
                                                            <MenuItem key={index} value={item.etlPatternId}>{item.patternName}</MenuItem>
                                                        );
                                                    })
                                            }
                                            <MenuItem value="-1" selected>None</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid> </>}

                            {/* if amazon s3 */}
                            {connection === "S3 Buckets" || connection === "Windows Fileshare" || layerType === "EXTRACT_WFS" ||
                                layerType === constants.EXTRACT_TYPES.adls ||
                                layerType === "EXTRACT_S3" ? <>
                                    <Grid item xs={12}>
                                        <h2>File Registration </h2>
                                    </Grid>
                                {
                                        layerType !== constants.EXTRACT_TYPES.adls ?
                                        <>
                                            <Grid item xs={3}>
                                                <FormControl sx={{ m: 1 }} fullWidth variant={(mode === constants.MODE.view) ? "standard" : "outlined"}>
                                                    <Picker
                                                        name='fileType'
                                                        label='File Type'
                                                        options={["CSV", "TSV", "AVRO"]}
                                                        value={configureTablesData.fileType.fieldValue}

                                                        error={configureTablesData.fileType.isError}
                                                        onChange={handleDropDownChange}
                                                        disabled={mode === constants.MODE.view}
                                                        readOnly={(mode === constants.MODE.view) ? true : false}
                                                    />
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <FormControl sx={{ m: 1 }} fullWidth variant={(mode === constants.MODE.view) ? "standard" : "outlined"}>
                                                    <DataField id="30ff3781-ebf1-408d-9369-16373cb24872"
                                                        label={connection === "Windows Fileshare" || layerType === "EXTRACT_WFS" ? 'Path' : 'Bucket Name'}
                                                        name='blobContainer'
                                                        value={configureTablesData.blobContainer.fieldValue}
                                                        error={configureTablesData.blobContainer.isError}
                                                        onChange={handleChange}
                                                        disabled={mode === constants.MODE.view}
                                                        readOnly={(mode === constants.MODE.view) ? true : false}
                                                    />
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <FormControl sx={{ m: 1 }} fullWidth variant={(mode === constants.MODE.view) ? "standard" : "outlined"}>
                                                    <DataField id="58fe54de-e540-458f-a4fd-0769dc58c8b0"
                                                        label='Regex'
                                                        name='regex'
                                                        value={configureTablesData.regex.fieldValue}
                                                        // error={configureTablesData.regex.isError}
                                                        onChange={handleChange}
                                                        disabled={mode === constants.MODE.view}
                                                        readOnly={(mode === constants.MODE.view) ? true : false}

                                                    />
                                                </FormControl>
                                            </Grid>
                                        </>
                                        : <></>
                                }
                                <Grid item xs={3}>
                                        <FormControl sx={{ m: 1 }} fullWidth>
                                            <InputLabel htmlFor='fieldDelimeter'>Field Delimeter</InputLabel>
                                        <Select
                                            label='fieldDelimeter'
                                            name='fieldDelimeter'
                                            id='fieldDelimeter'
                                            disabled={mode === constants.MODE.view}
                                            variant={
                                                mode === constants.MODE.view ? "standard" : "outlined"
                                            }
                                            onChange={onDropdownChange}
                                            value={configureTablesData.fieldDelimeter.fieldValue}
                                            defaultValue=','
                                            fullWidth
                                        >
                                            <MenuItem key='0' value=',' >Comma (,)</MenuItem>
                                            <MenuItem key='1' value=';'>Semi-colon (;)</MenuItem>
                                            <MenuItem key='2' value='\t'>Tab (\t)</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>

                                    <Grid item xs={3}>
                                        {<FormControl sx={{ m: 1 }} fullWidth >
                                            <InputLabel htmlFor='textDelimiter'>Text Delimiter</InputLabel>
                                            <Select
                                                label='textDelimiter'
                                                name='textDelimiter'
                                                id='textDelimiter'
                                                disabled={mode === constants.MODE.view}
                                                variant={
                                                    mode === constants.MODE.view ? "standard" : "outlined"
                                                }
                                                onChange={onDropdownChange}
                                                value={configureTablesData.textDelimiter.fieldValue}
                                                defaultValue='"'
                                                fullWidth
                                            >
                                                <MenuItem key='0' value="&#39;" >Single-Quotes (')</MenuItem>
                                                <MenuItem key='1' value='"'>Double-Quotes (")</MenuItem>
                                            </Select>


                                        </FormControl>
                                        }
                                    </Grid>
                                    <Grid item xs={3}>
                                        {<FormControl sx={{ m: 1 }} fullWidth >
                                            <InputLabel htmlFor='escapeChar'>Escape Char</InputLabel>
                                            <Select
                                                label='escapeChar'
                                                name='escapeChar'
                                                id='escapeChar'
                                                disabled={mode === constants.MODE.view}
                                                variant={
                                                    mode === constants.MODE.view ? "standard" : "outlined"
                                                }
                                            onChange={onDropdownChange}
                                                value={configureTablesData.escapeChar.fieldValue}
                                                defaultValue='"'
                                            fullWidth
                                        >
                                                <MenuItem key='0' value="&#39;" >Single-Quotes (')</MenuItem>
                                                <MenuItem key='1' value='"'>Double-Quotes (")</MenuItem>
                                        </Select>
                                        </FormControl>
                                        }

                                    </Grid>
                                    <Grid item xs={3}>
                                        <FormControl sx={{ m: 1 }} fullWidth variant={(mode === constants.MODE.view) ? "standard" : "outlined"}>
                                            <Picker
                                                name='deleteFiles'
                                                label='Delete Files'
                                                options={["Y", "N"]}
                                                value={configureTablesData.deleteFiles.fieldValue}
                                                disabled={mode === constants.MODE.view}
                                                readOnly={(mode === constants.MODE.view) ? true : false}
                                                onChange={handleDropDownChange}
                                            />
                                        </FormControl>
                                    </Grid>

                                <Grid item xs={3}>
                                    <FormControl sx={{ m: 1 }} fullWidth variant={(mode === constants.MODE.view) ? "standard" : "outlined"}>
                                        <Picker
                                            name='headerRows'
                                            label='Header Rows'
                                            options={["TRUE", "FALSE"]}
                                            value={configureTablesData.headerRows.fieldValue}
                                                disabled={mode === constants.MODE.view}
                                            readOnly={(mode === constants.MODE.view) ? true : false}
                                            onChange={handleDropDownChange}
                                        />
                                    </FormControl>
                                </Grid>


                                {/* Table */}
                                {mode !== constants.MODE.view ?
                                    <>
                                        <Grid item xs={12}>
                                            <h2>Import Fields </h2>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <AvroGenerator avroCode={avroCode} setAvroCode={setAvroCode} getAvroCode={getAvroCode}></AvroGenerator>
                                            <SqlGenerator sqlCode={sqlCode} setSqlCode={setSqlCode} setColumnGovernance={setColumnGovernance}></SqlGenerator>

                                        </Grid>
                                    </>
                                    : ''}
                            </> : props.customSQL ? <>
                                <Grid item xs={12}>
                                    <h2>Import Fields</h2>
                                </Grid>
                                <Grid item xs={12}>
                                    <AvroGenerator avroCode={avroCode} setAvroCode={setAvroCode} getAvroCode={getAvroCode}></AvroGenerator>
                                    <SqlGenerator sqlCode={sqlCode} setSqlCode={setSqlCode} setColumnGovernance={setColumnGovernance}></SqlGenerator>
                                </Grid>
                            </> : ''}

                            <Grid item xs={12}>
                                <h2>Field Attributes </h2>
                                <p>Define field-level attributes, data compliance treatments and row level filters. This process is required*.</p>
                            </Grid>
                            {/* Table Data */}

                            {columnGovernance ? <Grid item xs={12}>
                                <Stack spacing={2} alignItems='flex-start' style={{ width: '100%' }}>
                                    <Box sx={{ width: '100%', height: 400, bgcolor: 'background.paper' }}>

                                        <DataGrid
                                            // apiRef={apiRef}
                                            pagination
                                            onCellEditCommit={handleCommit}
                                            rows={columnGovernance}
                                            rowsPerPageOptions={[30, 50, 100]}
                                            columns={[
                                                {
                                                    field: 'srcColumnName',
                                                    headerName: 'Name (raw)',
                                                    width: 200,
                                                },
                                                {
                                                    field: 'srcDataType',
                                                    headerName: 'Type (raw)',
                                                    width: 120,
                                                },
                                                {
                                                    field: 'srcMaxLength',
                                                    headerName: 'Size (raw)',
                                                    width: 90,
                                                },
                                                {
                                                    field: 'srcPrecision',
                                                    headerName: 'Precision',
                                                    width: 75,
                                                },
                                                {
                                                    field: 'srcScale',
                                                    headerName: 'Scale',
                                                    width: 75,
                                                },
                                                {
                                                    field: 'synColumnName',
                                                    headerName: 'Name',
                                                    width: 120,
                                                },
                                                {
                                                    field: 'synDataType',
                                                    headerName: 'Type',
                                                    width: 120,
                                                },
                                                {
                                                    field: 'synMaxLength',
                                                    headerName: 'Size',
                                                    width: 90,
                                                },
                                                {
                                                    field: 'treatmentLevel',
                                                    headerName: 'Treatment',
                                                    width: 120,
                                                    editable: mode === "View" ? false : true,
                                                    renderEditCell: renderTreatmentCell,
                                                    valueGetter: (params) => getTreatmentValue(params.row.securityClassification, params.row.privacyClassification),
                                                },
                                                {
                                                    field: 'securityClassification',
                                                    headerName: 'Security',
                                                    width: 190,
                                                    editable: mode === "View" ? false : true,
                                                    renderEditCell: renderSecurityCell,
                                                },
                                                {
                                                    field: 'privacyClassification',
                                                    headerName: 'Privacy',
                                                    width: 190,
                                                    editable: mode === "View" ? false : true,
                                                    renderEditCell: renderPrivacyCell,
                                                },
                                            ]}
                                        />
                                    </Box>
                                </Stack>
                            </Grid> : ''}

                            <Grid item xs={12}>
                                <h2>Technical</h2>
                                <p>Note: When no comparison key/s are selected, all columns are used for delta processing.</p>
                            </Grid>

                            {(connection === "S3 Buckets" || connection === "Windows Fileshare" || !props.customSQL) ?
                                ''
                                : <Grid item xs={6}>
                                    <FormControl sx={{ m: 1 }} variant={(mode === constants.MODE.view) ? "standard" : "outlined"} fullWidth required={false}>

                                        <DataField id="d0c82949-f020-4a9b-8eba-81e558bae76b"
                                            type='textarea'
                                            name='customsql'
                                            label="Custom SQL"
                                            disabled={mode === "View" ? true : false}
                                            multiline={true}
                                            rows={mode === "View" ? 1 : 3}
                                            readOnly={(mode === constants.MODE.view) ? true : false}
                                            value={configureTablesData.customsql.fieldValue}
                                            error={configureTablesData.customsql.isError}
                                            onChange={handleChange}
                                        />
                                    </FormControl>
                                </Grid>}
                            {mode === constants.MODE.view && configureTablesData.customsql.fieldValue !== null ?
                                <Grid item xs={6}>
                                    <DataField id="c63aba3d-8886-41dd-a765-fe8dc74629cb"
                                        type="textarea"
                                        name="customsql"
                                        label="Custom SQL"
                                        disabled={mode === "View" ? true : false}
                                        multiline={true}
                                        rows={3}
                                        value={configureTablesData.customsql.fieldValue}
                                        error={configureTablesData.customsql.isError}
                                        onChange={handleChange}
                                    />
                                </Grid> : ''
                            }
                            {columnGovernance ? <>
                                <Grid item xs={6}>
                                    <FormControl sx={{ m: 1 }} variant={(mode === constants.MODE.view) ? "standard" : "outlined"} fullWidth required={false}>
                                        <InputLabel htmlFor="comparisonKeyLabel">Comparison Keys</InputLabel>
                                        <Select
                                            name='comparisonKey'
                                            label='Comparison Key'
                                            labelId='comparisonKeyLabel'
                                            fullWidth
                                            multiple
                                            variant={mode === "View" ? "standard" : "outlined"}
                                            value={comparisonKey}
                                            onChange={(event) => {
                                                let v = event.target.value as string[];
                                                setComparisonKey(v);
                                            }}
                                            disabled={mode === "View" ? true : false}
                                            sx={{ textAlign: 'left' }}
                                        >
                                            {
                                                columnGovernance && columnGovernance?.map((item: any, index: number) => {
                                                    return (
                                                        <MenuItem key={index} value={item.synColumnName}>{item.synColumnName}</MenuItem>
                                                    );
                                                })
                                            }
                                            {/* {mode !== "Add" ? <MenuItem value={comparisonKey}>{comparisonKey}</MenuItem> : ''} */}
                                            {mode === "View" ? comparisonKey?.map((item: any, index: number) => {
                                                return (
                                                    <MenuItem value={item?.toUpperCase()} key={index}>{item?.toUpperCase()}</MenuItem>
                                                );
                                            }) : ''}

                                        </Select>
                                    </FormControl>
                                </Grid>

                            </>
                                : ''}


                            {/* View Extractor Buttons */}
                            {mode === "View" ?
                                <Grid item xs={12}>
                                    <Box display="flex" justifyContent="flex-start" style={{ marginBottom: '1em' }}>
                                        <ExtractorStatus batchCode={batchCode ? batchCode : ''} enabled={taskDisabled}></ExtractorStatus>
                                        <Button id="4ba65f8b-3135-4b2f-8022-0c021b862943" color="primary" variant="contained" onClick={viewExtractorList} sx={{ m: 1 }}>
                                            View Extractors
                                        </Button>
                                        <Button id="b5a073cc-e019-4cb5-8f80-af7c004a1b6f" color="primary" variant="contained" onClick={viewSource} sx={{ m: 1 }}>
                                            View Source</Button>
                                        {(displayEditBtn || isAdmin) && (<Button id="da9e60f8-5d32-4c85-a484-0e6bc62a7076" color="primary" variant="contained" onClick={editExtractor} sx={{ m: 1 }}>
                                            Edit </Button>)}
                                        {isAdmin && <><Button id="deleteExtBtn" color="primary" variant="contained" onClick={() => setOpenConfirmationDialog(true)} sx={{ m: 1 }}>
                                            Delete</Button>
                                            <>
                                                <CustomizedDialogs
                                                    dialogHeight=''
                                                    modalSize="md"
                                                    key="target"
                                                    modalTitle="Delete Confirmation"
                                                    isOpen={openConfirmationDialog}
                                                    onClose={handleClose}
                                                    footerAction={
                                                        <Stack direction="row" spacing={2}>
                                                            <Button id="yesBtn" color="primary" onClick={() => deleteExtractor()} autoFocus>
                                                                Yes
                                                            </Button>
                                                            <Button id="noBtn" color="primary" onClick={handleClose}>
                                                                No
                                                            </Button>
                                                        </Stack>
                                                    }
                                                >
                                                    <>Are you sure you want to delete the extractor?</>
                                                </CustomizedDialogs>
                                            </>
                                        </>}
                                        <Button id="viewLoadersBtn" color="primary" variant="contained" onClick={viewLoaders} sx={{ m: 1 }}>View Loaders</Button>
                                    </Box>
                                </Grid>

                                : ''}


                            {/* Triggers */}
                            <Grid item xs={12}>
                                {mode !== constants.MODE.add ?
                                    <>
                                        {jobList && jobList.length > 0 ? <>
                                            <h2>Next Runtime</h2>
                                        </> : ""}

                                    </> : ""}
                                {mode !== constants.MODE.add ?
                                    <>
                                        {outboundPendingList || eventsPending || inboundPendingList ? 'Loading...' :
                                            <>
                                                {jobList && jobList.length > 0 && jobList?.map((job: any, index: number) => {
                                                    return <div key={index}> {cronstrue.toString(job.cronExpression)} (UTC {job.timezone})</div>

                                                })}
                                                {(jobList && jobList.length > 0) || (eventList && eventList.length > 0) ? <>
                                                    <h2>Triggers</h2>
                                                </> : ""}

                                                {jobList && jobList.length > 0 && jobList?.map((job: any, index: number) => {
                                                    return <div key={index}>{cronstrue.toString(job.cronExpression)} (UTC {job.timezone})</div>

                                                })}
                                                {eventList && eventList.length > 0 && eventList?.map((task: any, index: number) => {
                                                    return <div key={index}> {
                                                        task.eventType === "EXTRACT_TASK.SUCCESS"
                                                            ? `Events: ${task.description ? task.description : 'No description'}`
                                                            : `Inbound Webhook: ${AppConfig().BaseUrl}api/v1/webhooks/${task.eventQualifier}?type=extractor`
                                                    }</div>

                                                })}

                                                {outbound && outbound.length > 0 ?
                                                    <>
                                                        <h2>Actions</h2>
                                                        {/* <p>Actions to take once the task has successfully completed. </p> */}

                                                        {outbound && outbound.length > 0 && outbound.map((task: any, index: number) => {
                                                            return <div key={index}> Webhook: {task.eventActionValue ? task.eventActionValue : ''} {task.outboundWebhookHeader ? ` - ${task.outboundWebhookHeader}` : ''}
                                                            </div>
                                                        })}

                                                    </>
                                                    : ''}
                                            </>}
                                    </>


                                    :
                                    <>
                                        <h2>Extraction</h2>
                                        <p>Tasks must be run manually unless a trigger is added to run repeatedly.</p>
                                        <h3>Triggers</h3>
                                        <Box display="flex" justifyContent="flex-start" style={{ marginBottom: '1em' }}>
                                            <Button id="feb3a741-e3c9-48d5-8070-995cbbaddebf" color="primary" variant="contained" onClick={addTrigger}>Add New </Button>
                                        </Box>
                                        <div>
                                            <p>Triggers for the task to commence.</p>
                                            {triggers.map((trigger) => (
                                                <React.Fragment key={trigger.key}>
                                                    {trigger.key !== 0 ?
                                                        <Box sx={{ border: 1, borderColor: 'divider', padding: 2, width: '100%', display: 'block' }}>
                                                            <Grid container spacing={5} alignItems="center">
                                                                <TriggerRow value={trigger} onChange={onTriggerChange} type={'extractor'} />
                                                                <Grid item xs={1}>
                                                                    <IconButton color="primary" aria-label="upload picture" component="span" onClick={() => deleteTrigger(trigger.key)} >
                                                                        <DeleteSharpIcon />
                                                                    </IconButton>
                                                                </Grid>
                                                            </Grid>
                                                        </Box>
                                                        : <></>}
                                                </React.Fragment>
                                            ))}
                                        </div>
                                        <h2>Actions</h2>
                                        <p>
                                            Actions to take once the task has successfully completed.{" "}
                                        </p>
                                        <h3>
                                            Outbound Webhooks{" "}
                                            <Tooltip title="Once the task runs successfully, a message will be sent via an API/webhook">
                                                <IconButton>
                                                    <InfoIcon />
                                                </IconButton>
                                            </Tooltip>
                                        </h3>
                                        <>
                                            <Box
                                                display="flex"
                                                justifyContent="flex-start"
                                                style={{ marginBottom: "1em" }}
                                            >
                                                <Button id="a41bc212-8b82-4483-b4f5-6b6d0747af45"
                                                    color="primary"
                                                    variant="contained"
                                                    onClick={addAction}
                                                >
                                                    Add New{" "}
                                                </Button>
                                            </Box>
                                            <div>
                                                {actions.map((actionItem) => (
                                                    <React.Fragment key={actionItem.key}>
                                                        <Box
                                                            sx={{
                                                                border: 1,
                                                                borderColor: "divider",
                                                                padding: 2,
                                                                width: "100%",
                                                                display: "block",
                                                            }}
                                                        >
                                                            <Grid container spacing={5} alignItems="center">
                                                                <ActionRow
                                                                    value={actionItem}
                                                                    onChange={onActionChange}
                                                                />
                                                                <Grid item xs={1}>
                                                                    <IconButton
                                                                        color="primary"
                                                                        aria-label="upload picture"
                                                                        component="span"
                                                                        onClick={() => deleteAction(actionItem.key)}
                                                                    >
                                                                        <DeleteSharpIcon />
                                                                    </IconButton>
                                                                </Grid>
                                                            </Grid>
                                                        </Box>
                                                    </React.Fragment>
                                                ))}
                                            </div>
                                        </>
                                    </>

                                }
                            </Grid>

                            {mode === "View" ? '' :
                                <Grid item xs={12}>
                                    <Box display="flex" justifyContent="flex-end">
                                        {
                                            <Button id="386c6f3c-6906-49c8-9efc-28a80176ddbd"
                                                variant="contained"
                                                onClick={goBack}
                                                style={{ marginRight: "1em", marginTop: '1em' }}
                                            >
                                                Cancel
                                            </Button>
                                        }
                                        {pending && processingExtractor ?
                                            <>
                                                <LoadingButton loading loadingPosition="start" style={{ marginTop: '1em' }} variant="outlined" size="small" startIcon={<SaveIcon />} >Processing </LoadingButton>
                                                <ProgressPopup open={true} />
                                            </> :
                                            custExtpending && processingExtractor ?
                                                <>
                                                    <LoadingButton loading loadingPosition="start" style={{ marginTop: '1em' }} variant="outlined" size="small" startIcon={<SaveIcon />} >Processing </LoadingButton>
                                                    <ProgressPopup open={true} />
                                                </> :
                                                custExtbatchCode && !custExtError?.errorCode ?
                                                    <Button id="0589fd8d-a4bd-4197-b870-887f36350810" variant="contained" style={{ marginTop: '1em' }} onClick={() => viewextractor(custExtbatchCode)}>View Extractor</Button>
                                                    :
                                                    dbBatchCode && !dbExtError?.errorCode ?
                                                        <Button id="0589fd8d-a4bd-4197-b870-887f36350810" variant="contained" style={{ marginTop: '1em' }} onClick={() => viewextractor(dbBatchCode)}>View Extractor</Button>
                                                        :
                                                        <Button id="fcb3009a-57f8-4c32-8abf-cd5ab7e6a9f9" variant="contained" disabled style={{ marginTop: '1em' }} onClick={validateForm}>Create Extractor</Button>
                                        }
                                    </Box>
                                </Grid>
                            }
                            {mode !== "Add" ? <>
                                <Grid item xs={6}>
                                    <Box display="flex" justifyContent="flex-start">
                                        Last Updated By: {lastUpdated}
                                    </Box>
                                    <Box display="flex" justifyContent="flex-start">
                                        Last Modified On: {lastModified}
                                    </Box>
                                    <Box display="flex" justifyContent="flex-start">
                                        Last Refreshed: {lastRefreshed}
                                    </Box>
                                </Grid>
                                <Grid item xs={6}>
                                    <Box display="flex" justifyContent="flex-end">
                                        Created By: {createdBy}
                                    </Box>
                                    <Box display="flex" justifyContent="flex-end">
                                        Created On: {createdOn}
                                    </Box>
                                </Grid>
                            </> : ''}
                        </Grid>
                    }
                </Form>
            </div>
        </Formik >
    );
};


// creating a privacy cell
const renderPrivacyCell = (params: any) => {
    return <SelectPrivacyCell {...params} />;
};


function SelectPrivacyCell(props: any) {
    const { id, value, field } = props;
    const apiRef = useGridApiContext();

    if (props.row.securityClassification === "Confidential") {
        cellEnablePrivacy = true;
    }
    else {
        cellEnablePrivacy = false;
    }

    const handleChange = async (event: any) => {
        await apiRef.current.setEditCellValue({
            id,
            field,
            value: event.target.value,
        });

    };

    return (
        <Select
            value={value}
            onChange={handleChange}
            size='small'
            sx={{ height: 1 }}
            native
            autoFocus
        >
            <option value="" disabled selected>Select</option>
            <option value={constants.PRIVACY_CLASS.none}>None</option>
            <option disabled={cellEnablePrivacy === false} value={constants.PRIVACY_CLASS.personal}>{constants.PRIVACY_CLASS.personal}</option>
            <option disabled={cellEnablePrivacy === false} value={constants.PRIVACY_CLASS.sensitive}>{constants.PRIVACY_CLASS.sensitive}</option>
        </Select>
    );
}


// creating a security cell
const renderSecurityCell = (params: any) => {
    return <SelectSecurityCell {...params} />;
};


function SelectSecurityCell(props: any) {
    const { id, value, field } = props;
    const apiRef = useGridApiContext();

    const handleChange = async (event: any) => {
        await apiRef.current.setEditCellValue({
            id,
            field,
            value: event.target.value,
        });
    };

    return (
        <Select
            value={value}
            onChange={handleChange}
            size='small'
            sx={{ height: 1 }}
            native
            autoFocus
        >
            <option value="none" disabled selected>Select</option>
            <option value={constants.SECURITY_CLASS.general}> {constants.SECURITY_CLASS.general}</option>
            <option value={constants.SECURITY_CLASS.confidential}> {constants.SECURITY_CLASS.confidential}</option>
            <option value={constants.SECURITY_CLASS.highlyConfidential}>{constants.SECURITY_CLASS.highlyConfidential}</option>
        </Select>
    );
}


// creating a treatment cell
const renderTreatmentCell = (params: any) => {
    return <SelectTreatmentCell {...params} />;
};


function SelectTreatmentCell(props: any) {
    const { id, value, field } = props;
    const apiRef = useGridApiContext();

    const handleChange = async (event: any) => {
        await apiRef.current.setEditCellValue({
            id,
            field,
            value: event.target.value,
        });
        apiRef.current.stopCellEditMode({ id, field });
    };

    return (
        <Select
            value={value}
            onChange={handleChange}
            size='medium'
            sx={{ height: 80 }}
            native
            autoFocus
        >
            <option value="None" selected>Select</option>
            <option value="Low">Low</option>
            <option value="Medium">Medium</option>
            <option value="High">High</option>
        </Select>
    );
}

//Setting treatment at Row Level
const getTreatmentValue = (security: string, privacy: string) => {
    if (security === 'Highly Confidential') {
        return 'high';
    } else if (security === 'Confidential') {
        if (privacy === 'None') {
            return 'medium';
        } else if (privacy === 'Personal Data') {
            return 'high';
        } else if (privacy === 'Sensitive Data') {
            return 'very-high';
        }
    }
    else {
        return 'low';
    }
}

export default ConfigureTablesForm;